import { RootState } from 'store';

const LeaveCodesLookupState = (state: RootState) => state.lookups.leaveCodes;

export const selectLeaveCodes = (state: RootState) => LeaveCodesLookupState(state).rows;
